import DriverTipsInfoModal from './DriverTipsInfoModal';

export default DriverTipsInfoModal;
